import { createEvent } from 'ics';

export const PermissionTypes = {
    myTeam: 'my-team',
    questionRegistries: 'question-registry',
    questionBoard: 'questions',
    diologIntegration: 'integrate-diolog',
    announcements: 'announcements',
    calendar: 'calendar',
    webform: 'web-form',
    emailExtension: 'email-extension',
    companyDetails: 'company-details',
    executiveTeam: 'excutive-team'
};

export const filtersPage = [
    'my-team',
    'questions',
    'question-registry',
    'announcements',
    'integrate-diolog',
    'web-form',
    'email-extension',
    'calendar',
    'company-details',
    'excutive-team'
];

export const backendPermssionTypes = {
    myTeam: 'myTeam',
    questionRegistries: 'questionRegistries',
    questionBoard: 'questionBoard',
    diologIntegration: 'diologIntegration',
    announcements: 'announcements',
    calendar: 'calendar',
    companyDetails: 'companyDetails',
    questionManagement: 'questionManagement',
    administrative: 'administrative',
    inviteStaff: 'inviteStaff',
    createEvent: 'createEvent'
};
